import { FC } from 'react';
import { FieldErrors } from 'react-hook-form';

import { ErrorSummary } from './FormA11yErrorAnnouncer.styles';
import useFormAccessibility from './useFormAccessibility';

interface FormA11yErrorAnnouncerProps {
  errors: FieldErrors;
  keyMapper?: { [key: string]: string | null };
}

export const FormA11yErrorAnnouncer: FC<FormA11yErrorAnnouncerProps> = ({ errors, keyMapper = {} }) => {
  const { errorSummaryRef } = useFormAccessibility(errors, keyMapper);

  return <ErrorSummary ref={errorSummaryRef} role="alert" aria-live="polite"></ErrorSummary>;
};
